<template>
  <v-row justify="center" no-gutters>
    <v-col class="msg-wrapper">
      <v-row
        no-gutters
        justify="space-between"
        class="msg"
        :class="{ owner ,'secondary': owner == true }"
      >
        <v-col>
          <span class="font-weight-bold">{{user.first_name + ' '+user.last_name}}</span>
          <p class="mb-0">{{message}}</p>
        </v-col>
        <v-col cols="auto">
          <span class="msg__date ml-3">{{created_at}}</span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ""
    },
    owner: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: {}
    },
    created_at: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-wrapper {
  display: flex;
  flex-direction: column;
}
.msg {
  padding: 1rem;
  width: 60%;
  margin: 0 1rem;
  box-shadow: 0 1px 0 0 rgba(50, 50, 50, 0.3);
  border-radius: 4px;
  background: #1976d2;
  color: #fff;
  position: relative;
  word-break: break-all;
  margin-bottom: 1rem;
  &__date {
    text-decoration: underline;
  }
}
.owner {
  background: #1976d2;
  color: #fff;
  align-self: flex-end;
}
@media (max-width: 400px) {
  .msg {
    width: 90%;
  }
}
</style>